import { SearchConsoleAccountOTPInputsValidationSchema } from '@/modules/DomainsApi';

export const searchConsoleAccountOTPInputsValidationSchema: SearchConsoleAccountOTPInputsValidationSchema = {
  secret: [{
    type: 'string',
    required: true,
    message: 'Укажіть ключ налаштування',
  }, {
    max: 255,
    message: 'Максимальна довжина ключа 255 символів',
  }]
};
